// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"0a16cedf","508":"503adc33","653":"77123a0d","690":"9a412424","704":"846b86eb","987":"9a412424"}[chunkId] + ".chunk.css";
};